import React from "react";
import PropTypes from "prop-types";
import numericalFieldHandler from "../../../utils/numericalFieldHandler";
import translateLabel from "../../../utils/translateLabel";

const RepeatDaily = ({
	id,
	daily: { interval },
	handleChange,
	translations,
}) => (
	<div className="field is-grouped columns is-multiline is-mobile is-vcentered">
		<div className="control column is-narrow">
			{translateLabel(translations, "repeat.daily.every")}
		</div>
		<div className="control column is-narrow">
			<input
				id={`${id}-interval`}
				name="repeat.daily.interval"
				aria-label="Repeat daily interval"
				className="input"
				value={interval}
				onChange={numericalFieldHandler(handleChange)}
			/>
		</div>
		<div className="control column is-narrow">
			{translateLabel(translations, "repeat.daily.days")}
		</div>
	</div>
);
RepeatDaily.propTypes = {
	id: PropTypes.string.isRequired,
	daily: PropTypes.shape({
		interval: PropTypes.number.isRequired,
	}).isRequired,
	handleChange: PropTypes.func.isRequired,
	translations: PropTypes.oneOfType([PropTypes.object, PropTypes.func])
		.isRequired,
};

export default RepeatDaily;
